import { createReducer, on } from '@ngrx/store';

import { MapActions } from './map.actions';
import { MapState } from './map.state';

const GERMANY_LOCATION = {
  latitude: 50.520008,
  longitude: 8.404954,
};

export const initMapState: MapState = {
  installations: [],
  searchedInstallations: [],
  selectedInstallations: [],
  latitude: GERMANY_LOCATION.latitude,
  longitude: GERMANY_LOCATION.longitude,
  showSearch: false,
  zoom: 7,
  loaded: false,
  loading: false,
  error: null,
};

export const mapReducer = createReducer(
  initMapState,

  on(
    MapActions.listInstallations,
    (): MapState => ({
      ...initMapState,
      loaded: false,
    })
  ),

  on(
    MapActions.listInstallationsError,
    (state, { error }): MapState => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.loadFirstThousandInstallations,
    (state): MapState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    MapActions.loadFirstThousandInstallationsSuccess,
    (state, { installations }): MapState => ({
      ...state,
      installations: [...installations],
      error: null,
    })
  ),

  on(
    MapActions.loadFirstThousandInstallationsError,
    (state, { error }): MapState => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.loadSecondThousandInstallations,
    (state): MapState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    MapActions.loadSecondThousandInstallationsSuccess,
    (state, { installations }): MapState => ({
      ...state,
      installations: [...state.installations, ...installations],
      error: null,
    })
  ),

  on(
    MapActions.loadSecondThousandInstallationsError,
    (state, { error }): MapState => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.loadThirdThousandInstallations,
    (state): MapState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    MapActions.loadThirdThousandInstallationsSuccess,
    (state, { installations }): MapState => ({
      ...state,
      installations: [...state.installations, ...installations],
      error: null,
    })
  ),

  on(
    MapActions.loadThirdThousandInstallationsError,
    (state, { error }): MapState => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.listLockedInstallations,
    (state): MapState => ({
      ...state,
      loading: true,
    })
  ),

  on(
    MapActions.listLockedInstallationsSuccess,
    (state, { lockedInstallations }): MapState => {
      if (lockedInstallations?.length) {
        state.installations.map((inst) => {
          const isColdSystem = lockedInstallations.some(
            (lockedInstallation) => inst.id === lockedInstallation.id
          );

          inst.isColdSystem = isColdSystem;
        });
      }

      return {
        ...state,
        loading: false,
        loaded: true,
      };
    }
  ),

  on(
    MapActions.listLockedInstallationsError,
    (state, { error }): MapState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  ),

  on(
    MapActions.loadMapSuccess,
    (state, { installations }): MapState => ({
      ...state,
      showSearch: true,
      installations: [...installations],
      searchedInstallations: [...installations],
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.loadMapError,
    (state, { error }): MapState => ({
      ...state,
      error,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.loadInstallation,
    (state): MapState => ({
      ...state,
      error: null,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.loadInstallationSuccess,
    (state, { installation }): MapState => ({
      ...state,
      showSearch: false,
      installations: [...state.installations, installation],
      selectedInstallations: [installation],
      searchedInstallations: [...state.searchedInstallations, ...[installation]],
      latitude: installation.latitude,
      longitude: installation.longitude,
      zoom: 20,
      loading: false,
      loaded: true,
    })
  ),

  on(
    MapActions.selectInstallation,
    (state): MapState => ({
      ...state,
    })
  ),

  on(
    MapActions.selectInstallationSuccess,
    (state, { selectedInstallations }): MapState => ({
      ...state,
      selectedInstallations,
      latitude: selectedInstallations[0].latitude,
      longitude: selectedInstallations[0].longitude,
      zoom: 20,
    })
  ),

  on(
    MapActions.unselectInstallation,
    (state): MapState => ({
      ...state,
      selectedInstallations: [],
      latitude: null,
      longitude: null,
    })
  ),

  on(
    MapActions.searchInstallationsSuccess,
    (state, { searchedInstallations }): MapState => ({
      ...state,
      searchedInstallations,
    })
  ),

  on(
    MapActions.clearSearch,
    (state): MapState => ({
      ...state,
      searchedInstallations: state.installations,
    })
  ),

  on(
    MapActions.focusOnLocationOfFirstInstallation,
    (state, { location }): MapState => ({
      ...state,
      latitude: location.latitude,
      longitude: location.longitude,
    })
  )
);
